import React from "react";
import { FiltersTypes } from "@common/types/filters/general";
import {
    TASK_PRIORITY_BY_FILTER_VALUE,
    TASK_PRIORITY_CONFIG,
} from "@components/tasks/TaskPrioritySelect/taskPriority.constant";

interface Props {
    filters: FiltersTypes;
}

export const TaskPriorityFilterLabel: React.FC<Props> = ({ filters }) => {
    const { taskPriorities } = filters;

    if (!taskPriorities || taskPriorities.length === 0) {
        return null;
    }

    if (taskPriorities.length === 1) {
        return (
            <span>
                {
                    TASK_PRIORITY_CONFIG[
                        TASK_PRIORITY_BY_FILTER_VALUE[taskPriorities[0]]
                    ].label
                }
            </span>
        );
    }

    return <span>{taskPriorities.length} priorities</span>;
};
